import { useTemplatesViewModel } from '@viewModels/TemplatesViewModel/TemplatesViewModel';
import css from './CartItem.module.css';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { GetImageFromGalleries } from '@modules/Steps/Shared/Helpers/GetImageFromGalleries';
import { DEFAULT_TEMPLATE_IMG } from '@shared/Constants/Images/DefaultTemplateImg';
import { TEMPLATE_PRICE } from '@shared/Constants/TemplatePrice';
import classNames from 'classnames';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { DeleteTemplateFromCartWarningModal } from '@modules/BillOfMaterials/Shared/Widgets/Modals/DeleteTemplateFromCartWarningModal/DeleteTemplateFromCartWarningModal';
import { ROUTES } from '@configs/AppRoutes';
import DeleteButton from '@shared/Ui/Buttons/DeleteButton/DeleteButton';

export const CartItem: React.FC = () => {
    const { currentTemplate } = useTemplatesViewModel();
    const [isDesktop] = useMediaType();
    const navigate = useNavigate();
    const { tempId } = useParams();

    const categories = currentTemplate?.categories
        ? currentTemplate?.categories.map(c => c.category).join(', ')
        : [];

    const imgUrl = GetImageFromGalleries(
        DEFAULT_TEMPLATE_IMG,
        currentTemplate?.galleries
    );

    const templatePrice = currentTemplate?.paid ? TEMPLATE_PRICE : '0.00';

    const [isDeleteTemplateModalOpen, setIsDeleteTemplateModalOpen] =
        useState(false);
    const handleOpenDeleteTemplateModal = () =>
        setIsDeleteTemplateModalOpen(true);
    const handleCloseDeleteTemplateModal = () =>
        setIsDeleteTemplateModalOpen(false);

    const handleDeleteTemplateFromCart = () => {
        if (tempId) {
            navigate(ROUTES.TEMPLATE_INFO.getPath(tempId));
        }
    };

    return (
        <div className={css.cartItem}>
            {isDesktop && (
                <div className={css.cartItemHeader}>
                    <span className={classNames(css.headerItem, css.cart)}>
                        Cart
                    </span>
                    <span className={classNames(css.headerItem, css.subtotal)}>
                        Subtotal
                    </span>
                    <span className={classNames(css.headerItem, css.action)}>
                        Action
                    </span>
                </div>
            )}
            <div className={css.content}>
                <div className={css.imgAndTitle}>
                    <img src={imgUrl} alt="template img" className={css.img} />
                    <div className={css.contentText}>
                        <div className={css.template}>
                            Template{' '}
                            <span className={css.templateTitle}>
                                {currentTemplate?.title}
                                <span>({categories})</span>
                            </span>
                        </div>
                        {!isDesktop && (
                            <div className={css.price}>R {templatePrice}</div>
                        )}
                    </div>
                </div>
                {isDesktop && (
                    <div className={css.price}>R {templatePrice}</div>
                )}
                <DeleteButton
                    extraClassName={css.btn}
                    onClick={handleOpenDeleteTemplateModal}
                />
            </div>
            {isDeleteTemplateModalOpen && (
                <DeleteTemplateFromCartWarningModal
                    templateTitle={currentTemplate?.title}
                    onClose={handleCloseDeleteTemplateModal}
                    onConfirm={handleDeleteTemplateFromCart}
                />
            )}
        </div>
    );
};
